var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdministration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.66667 3.33325H5L2.5 11.6666",
    stroke: "#9E9B99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M13.3333 3.33325H14.9999L17.4999 11.6666",
    stroke: "#9E9B99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M8.33325 13.3334H11.6666",
    stroke: "#9E9B99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M17.5001 13.7501C17.5001 15.3609 16.1942 16.6667 14.5834 16.6667C12.9726 16.6667 11.6667 15.3609 11.6667 13.7501V11.6667H17.5001V13.7501",
    stroke: "#9E9B99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M8.33333 13.7501C8.33333 15.3609 7.0275 16.6667 5.41667 16.6667C3.80584 16.6667 2.5 15.3609 2.5 13.7501V11.6667H8.33333V13.7501",
    stroke: "#9E9B99",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdministration);
export default __webpack_public_path__ + "static/media/administration.e21a9d3df5c41aeb644f3ea2dd0e3b73.svg";
export { ForwardRef as ReactComponent };